import { createCoreMethod } from '../../utils/createCoreMethod';

export const getFlowPageName = createCoreMethod(
  'getFlowPageName',
  async (nodeId: string) => {
    const tempLayer = figma.currentPage.children.find(
      (node) => node.name === 'velocity-temp-data'
    ) as FrameNode;

    if (!tempLayer) return null;

    const scenarioPageNode: BaseNode | null | undefined =
      tempLayer.children.find((child) => child.id === nodeId);

    if (!scenarioPageNode) return null;

    return {
      name: scenarioPageNode.name,
    };
  }
);
